// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentId_ONLINE_CONTENT } from "../schema";

export function serialize_ContentId_ONLINE_CONTENT_internal(value: ContentId_ONLINE_CONTENT): unknown {
  return ((value: { contentType: "ONLINE_CONTENT"; id: bigint }): unknown => {
    return {
      contentType: ((value: "ONLINE_CONTENT"): unknown => {
        return value;
      })(value["contentType"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
    };
  })(value);
}
export function serialize_ContentId_ONLINE_CONTENT(obj: ContentId_ONLINE_CONTENT): string {
  return renderJsonWithNumbersAsBigint(serialize_ContentId_ONLINE_CONTENT_internal(obj));
}
export function deserialize_ContentId_ONLINE_CONTENT_internal(value: unknown): ParserResult<ContentId_ONLINE_CONTENT> {
  return ((
    value: unknown,
  ): ParserResult<{
    contentType: "ONLINE_CONTENT";
    id: bigint;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/OnlineContentId]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/OnlineContentId]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "contentType")) {
      return { success: false, reason: `[#/components/schemas/OnlineContentId/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
    }
    const parsed_contentType = ((): ParserResult<"ONLINE_CONTENT"> => {
      return ((value: unknown): ParserResult<"ONLINE_CONTENT"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OnlineContentId/contentType]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "ONLINE_CONTENT":
            return { success: true, value: "ONLINE_CONTENT" };
          default:
            return { success: false, reason: `[#/components/schemas/OnlineContentId/contentType]: '${value}' expected to be enum, one of 'ONLINE_CONTENT'.` };
        }
      })(value["contentType"]);
    })();
    if (!parsed_contentType.success) {
      return { success: false, reason: parsed_contentType.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/OnlineContentId/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/OnlineContentId/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    return { success: true, value: { contentType: parsed_contentType.value, id: parsed_id.value } };
  })(value);
}
export function deserialize_ContentId_ONLINE_CONTENT(str: string): ParserResult<ContentId_ONLINE_CONTENT> {
  return deserialize_ContentId_ONLINE_CONTENT_internal(parseJsonWithNumbersAsBigint(str));
}
